import React from 'react'
import '../css/Home.css';
import cs1 from '../../images/news1.jpeg';
import cs2 from '../../images/news2.jpeg';
import cs3 from '../../images/news3.jpeg';
import cs4 from '../../images/news4.jpeg';
import cs5 from '../../images/news5.jpeg';
import cs6 from '../../images/news4.jpeg';
import cs7 from '../../images/blog13.png';
import cs8 from '../../images/blog15.png';
import cs9 from '../../images/blog9.png';
import cs10 from '../../images/blog10.png';
import cs11 from '../../images/blog11.png';
import cs12 from '../../images/blog12.png';
import cs13 from '../../images/b1.png';
import cs14 from '../../images/b2.png';
import cs15 from '../../images/b3.png';
import cs16 from '../../images/b4.png';

import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export const features = [
    {
        id: 1,
        image: cs1,
        alt: "Left",
        title: "Workflow Automation Software: Save Hours, Earn More",
        description: "How workflow automation software helps businesses save time, reduce manual effort, and boost productivity.",
        link: "/workflow-automation-software",
        animation: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 }, delay: 0 }
    },
     {
         id: 2,
         image: cs2,
         alt: "Center",
         title: "Invoice Approval Software: The Smart Choice for Business",
         description: "Discover how invoice approval software simplifies financial workflows and improves approval efficiency.",
         link: "/invoice-approval-software",
         animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
     },
     {
         id: 3,
         image: cs3,
         alt: "Right",
         title: "The Future of AI Product Development in E-Commerce Brands",
         description: "Exploring how AI-driven product development is reshaping the future of modern e-commerce brands.",
         link: "/the-future-of-ai-in-ecommerce",
         animation: { initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 }, delay: 0.2 }
     },
     {
         id: 4,
         image: cs4,
         alt: "Left",
         title: "Algo Trading Software: A Game Changer for Modern-Day Traders",
         description: "Why algorithmic trading software is revolutionizing trading strategies for today’s traders.",
         link: "/algo-trading-software",
         animation: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 }, delay: 0 }
     },
    // {
    //     id: 5,
    //     image: cs5,
    //     alt: "Center",
    //     title: "How a Custom ERP Can Save Your Operations Team 20+ Hours a Week",
    //     description: "Discover how custom ERP solutions can streamline operations and save valuable time for your team.",
    //     link: "/custom-erp-solutions",
    //     animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
    // },
    // {
    //     id: 6,
    //     image: cs6,
    //     alt: "Right",
    //     title: "Is Your User Data Actually Safe? 2026 Standards for Cybersecurity in SaaS",
    //     description: "How modern cybersecurity standards are protecting user data in SaaS applications.",
    //     link: "/cybersecurity-in-saas",
    //     animation: { initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 }, delay: 0.2 }
    // },
    {
        id: 7,
        image: cs7,
        alt: "Left",
        title: "Peregrinee’s Complete Guide to Custom Web App Development",
        description: "An in-depth look at Peregrinee’s Complete Guide to Custom Web App Development streamline operations and maximize ROI.",
        link: "/custom-web-app-development-peregrinee",
        animation: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 }, delay: 0 }
    },
    {
        id: 8,
        image: cs8,
        alt: "Center",
        title: "Web App Development Process at Peregrinee: From Idea to Launch",
        description: "Understanding how modern Web App Development Process at Peregrinee: From Idea to Launch",
        link: "/web-app-development-at-peregrinee",
        animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
    },
    {
        id: 9,
        image: cs9,
        alt: "Center",
        title: "Why Businesses Choose Peregrinee for Custom Software Development",
        description: "Explore why growing businesses trust Peregrinee for scalable, secure, and fully customized software solutions tailored to their operational needs.",
        link: "/why-businesses-choose-peregrinee",
        animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
    },
    {
        id: 10,
        image: cs10,
        alt: "Right",
        title: "How Peregrinee Delivers High-Performance Web Applications",
        description: "Discover how Peregrinee builds fast, scalable, and performance-optimized web applications using modern architecture and cutting-edge technologies.",
        link: "/high-performance-web-applications",
        animation: { initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 }, delay: 0.2 }
    },
    {
        id: 11,
        image: cs11,
        alt: "Left",
        title: "Peregrinee’s Approach to MVP Development for Startups",
        description: "Learn how Peregrinee helps startups validate ideas faster with lean MVP development, rapid prototyping, and scalable architecture planning.",
        link: "/mvp-development-for-startups",
        animation: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 }, delay: 0 }
    },
    {
        id: 12,
        image: cs12,
        alt: "Center",
        title: "Cost to Build a Web App in 2026 – Insights from Peregrinee",
        description: "Understand the real cost factors of web app development in 2026, including features, tech stack, scalability, and long-term maintenance considerations.",
        link: "/cost-to-build-web-app-2026",
        animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
    },
    {
        id: 13,
        image: cs13,
        alt: "Right",
        title: "React vs Angular vs Vue: Peregrinee’s Recommendation",
        description: "Compare React, Angular, and Vue frameworks and discover Peregrinee’s recommendation for building scalable, modern, and high-performance web applications.",
        link: "/react-vs-angular-vs-vue",
        animation: { initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 }, delay: 0.2 }
    },
    {
        id: 14,
        image: cs14,
        alt: "Left",
        title: "How Peregrinee Uses AI in Web Application Development",
        description: "Explore how Peregrinee integrates artificial intelligence into web applications to deliver smarter automation, predictive insights, and enhanced user experiences.",
        link: "/ai-in-web-application-development",
        animation: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 }, delay: 0 }
    },
    {
        id: 15,
        image: cs15,
        alt: "Center",
        title: "How Peregrinee Builds SaaS Web Applications",
        description: "Learn how Peregrinee designs and develops scalable SaaS platforms with secure architecture, subscription models, and cloud-ready infrastructure.",
        link: "/saas-web-application-development",
        animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
    },
    {
        id: 16,
        image: cs16,
        alt: "Right",
        title: "Fintech Web App Development with Peregrinee",
        description: "Discover how Peregrinee develops secure fintech web applications with advanced data protection, compliance readiness, and high-performance financial systems.",
        link: "/fintech-web-app-development",
        animation: { initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 }, delay: 0.2 }
    }


];


function BlogSection() {

    return (
        <><section id="blog-section" className="container my-5">
            <motion.section className="container my-5"
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: false, amount: 0.6 }}
                transition={{ duration: 0.8, ease: "easeOut" }}>
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">Our <span className="highlight-orange">Blogs</span>
                    </div>
                </div>
                <div className="d-flex justify-content-center mt-3">
                    <span className="text-center fw-bold" style={{ fontSize: '22px', color: '#000', fontWeight: '500' }}>
                        Insights, trends, and expert perspectives on <span className="highlight-orange">technology</span>, <span className="highlight-orange">innovation</span>, and <span className="highlight-orange">digital transformation</span>.
                    </span>

                </div>
                {/* <div className="d-flex justify-content-center mt-4">
        <a
            href="#contact-us"
            className="btn custom-orange-btn py-3 px-4 fw-bold"
        >
            Get in Touch With Us
        </a>
    </div> */}
            </motion.section>

        </section>
            <section className="container my-5">
                <div className="row g-4">
                    {features.map((feature, index) => (
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={feature.id}>
                            <Link to={feature.link} style={{ textDecoration: 'none' }}>
                                <motion.div
                                    className="card h-100 border-0 shadow-sm bg-white" style={{ backgroundColor: '#ffffff' }}
                                    initial={feature.animation.initial}
                                    whileInView={feature.animation.animate}
                                    transition={{ duration: 0.8, ease: "easeOut", delay: feature.animation.delay }}
                                    viewport={{ once: false, amount: 0.3 }}
                                >
                                    {/* IMAGE */}
                                    <img
                                        src={feature.image}
                                        alt={feature.alt}
                                        className="card-img-top img-fluid"
                                        style={{ height: '220px', objectFit: 'cover' }}
                                    />

                                    {/* CONTENT */}
                                    <div className="card-body">
                                        <h5 className="card-title text-dark fw-bold">
                                            {feature.title}
                                        </h5>
                                        <p className="card-text text-muted small">
                                            {feature.description}
                                        </p>

                                        <div className="d-flex justify-content-end mt-3">
                                            <span
                                                className="d-inline-flex align-items-center gap-2 rounded-pill"
                                                style={{
                                                    padding: '8px 16px',
                                                    backgroundColor: '#f57c00',
                                                    color: '#fff',
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.3s ease'
                                                }}
                                            >
                                                Read More
                                                <FaArrowRight size={14} />
                                            </span>
                                        </div>


                                    </div>
                                </motion.div>
                            </Link>
                        </div>


                    ))}
                </div>
            </section></>
    )
}

export default BlogSection